(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('publisher-ibq', {
            parent: 'entity',
            url: '/publisher-ibq?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.publisher.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/publisher/publishersibq.html',
                    controller: 'PublisherIbqController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('publisher');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('publisher-ibq-detail', {
            parent: 'publisher-ibq',
            url: '/publisher-ibq/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.publisher.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/publisher/publisher-ibq-detail.html',
                    controller: 'PublisherIbqDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('publisher');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Publisher', function($stateParams, Publisher) {
                    return Publisher.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'publisher-ibq',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('publisher-ibq-detail.edit', {
            parent: 'publisher-ibq-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/publisher/publisher-ibq-dialog.html',
                    controller: 'PublisherIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Publisher', function(Publisher) {
                            return Publisher.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('publisher-ibq.new', {
            parent: 'publisher-ibq',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/publisher/publisher-ibq-dialog.html',
                    controller: 'PublisherIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                address: null,
                                webPage: null,
                                phone: null,
                                email: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('publisher-ibq', null, { reload: 'publisher-ibq' });
                }, function() {
                    $state.go('publisher-ibq');
                });
            }]
        })
        .state('publisher-ibq.edit', {
            parent: 'publisher-ibq',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/publisher/publisher-ibq-dialog.html',
                    controller: 'PublisherIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Publisher', function(Publisher) {
                            return Publisher.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('publisher-ibq', null, { reload: 'publisher-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('publisher-ibq.delete', {
            parent: 'publisher-ibq',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/publisher/publisher-ibq-delete-dialog.html',
                    controller: 'PublisherIbqDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Publisher', function(Publisher) {
                            return Publisher.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('publisher-ibq', null, { reload: 'publisher-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
